module.exports = __webpack_public_path__ + "5bb9a8e38c0459c3870f2bc4e9621004.pdf";